"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compareAddress = compareAddress;
exports.generatePayload = generatePayload;
var _data = require("./data.config");
function compareAddress(values) {
  var _values$addressRespon, _values$addressRespon2, _values$addressRespon3, _values$addressRespon4;
  if (values.residentialAddress !== (values === null || values === void 0 || (_values$addressRespon = values.addressResponse) === null || _values$addressRespon === void 0 || (_values$addressRespon = _values$addressRespon.Address) === null || _values$addressRespon === void 0 ? void 0 : _values$addressRespon.Street1)) {
    return false;
  }
  if (values.city !== ((_values$addressRespon2 = values.addressResponse) === null || _values$addressRespon2 === void 0 || (_values$addressRespon2 = _values$addressRespon2.Address) === null || _values$addressRespon2 === void 0 ? void 0 : _values$addressRespon2.City)) {
    return false;
  }
  if (values.state !== ((_values$addressRespon3 = values.addressResponse) === null || _values$addressRespon3 === void 0 || (_values$addressRespon3 = _values$addressRespon3.Address) === null || _values$addressRespon3 === void 0 ? void 0 : _values$addressRespon3.State)) {
    return false;
  }
  if (values.zipCode !== ((_values$addressRespon4 = values.addressResponse) === null || _values$addressRespon4 === void 0 || (_values$addressRespon4 = _values$addressRespon4.Address) === null || _values$addressRespon4 === void 0 ? void 0 : _values$addressRespon4.Zip)) {
    return false;
  }
  return true;
}
function generatePayload(values) {
  var isFinalSubmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  // Reformat any fields before using in payload (i.e. remove dashes from phone, reformat date)
  var phoneNumber = values.phoneNumber.replace(/[-\s()]/g, '');
  var splitDate = values.dob.split('/');
  var dob = "".concat(splitDate[2], "-").concat(splitDate[0], "-").concat(splitDate[1]);
  var payload = {
    'party': {
      'person': {
        'birthDate': dob,
        'nameBase': {
          'givenName': values.firstName,
          'surname': values.lastName
        },
        'communication': {
          'phoneNumber': phoneNumber,
          'phoneExtension': '',
          'phoneCountryCode': '1',
          'emailAddress': values.email
        },
        'addressBase': {
          'line1': values.residentialAddress,
          'city': values.city,
          'stateOrProvinceCode': 'CA',
          'countryCode': 'US',
          'postalCode': values.zipCode
        }
      }
    }
  };
  if (isFinalSubmit) {
    var _values$identityRespo;
    // If this is final submission payload we must add dataPrivacy and caseId section of payload
    // 1. Create flag for authorizeRequestor?
    var {
      relationshipToMM,
      requestCategory,
      requestToCorrectText,
      isAuthorizedAgent
    } = values;
    var isAuthorizedRequestor = isAuthorizedAgent.includes('authorizedAgent');
    // 2. Create relationshipTypeCodes array
    var relationshipTypeCodes = [];
    relationshipToMM.map(relationship => {
      if (relationship != 'authorizedAgent') relationshipTypeCodes.push(_data.relationshipMap[relationship]);
    });
    // 3. Create privacyRequestTypeCodes array
    var privacyRequestTypeCodes = [];
    requestCategory.map(requestType => {
      privacyRequestTypeCodes.push(_data.requestTypeMap[requestType]);
    });
    payload.dataPrivacy = {
      'identityVerificationTypeCode': (_values$identityRespo = values.identityResponse) === null || _values$identityRespo === void 0 ? void 0 : _values$identityRespo.identityVerificationTypeCode,
      'privacyRequestTypeCodes': privacyRequestTypeCodes,
      'relationshipTypeCodes': relationshipTypeCodes,
      'authorizedRequestorInd': isAuthorizedRequestor
    };
    payload.caseId = values.caseId;
    if (requestCategory.includes('requestToCorrect')) payload.dataPrivacy.additionalInformation = requestToCorrectText;
  }
  return payload;
}